<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="notificaciones.length" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white" v-if="notificaciones.length == 1">{{ notificaciones.length }} Nueva</h3>
        <h3 class="text-white" v-else>{{ notificaciones.length }} Nuevas</h3>
        <p class="opacity-75">Notificaciones</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="ntf in notificaciones" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer" @click="notificacionNoLeida(ntf)">
            <router-link :to="getURL(ntf)" class="text-inherit hover:text-primary">
              <div class="flex items-start">
                <feather-icon :icon="getIcon(ntf.id_notification_type)" :svgClasses="[`text-${getBackgroundColor(ntf.id_notification_type)}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                <div class="mx-2">
                  <span class="font-medium block notification-title" :class="[`text-${getBackgroundColor(ntf.id_notification_type)}`]">{{ ntf.name_notification_type }}</span>
                  <small>{{ ntf.title_notification }}</small>
                </div>
              </div>
            </router-link>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created_at_notification) }}</small>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <router-link :to="{name: 'Notificaciones'}" @click.stop.prevent class="text-inherit hover:text-primary">
          <span>Ver todas las notificaciones</span>
        </router-link>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    notificaciones () {
      const notificaciones = this.$store.state.notifications
      const filtradoPorNotificacionesNoLeidas = notificaciones.filter(notificacion => notificacion.flag_read_notification === 0)
      return filtradoPorNotificacionesNoLeidas.sort((a, b) => Date.parse(b.created_at_notification) - Date.parse(a.created_at_notification))
    }
  },
  mounted () {
    this.$root.$on('notificationFired', () => {
    })
  },
  methods: {
    getURL (data) {
      if (data.user_type_notification_type === 'client') {
        return ''
      } else {
        return ''
        //  if(data.id_notification_type == '1') return "/admin/clientes"
        //  if(data.id_notification_type == '2') return "/admin/clientes"
        //  if(data.id_notification_type == '3') return 
        //  if(data.id_notification_type == '4') return 
        //  if(data.id_notification_type == '5') return 
        //  if(data.id_notification_type == '6') return 
        //  if(data.id_notification_type == '7') return 
        //  if(data.id_notification_type == '8') return 
        //  if(data.id_notification_type == '9') return 
        //  if(data.id_notification_type == '10') return 
        //  if(data.id_notification_type == '11') return 
        //  if(data.id_notification_type == '12') return 
        //  if(data.id_notification_type == '13') return 
        //  if(data.id_notification_type == '14') return 
        //  if(data.id_notification_type == '15') return 
        //  if(data.id_notification_type == '16') return 
        //  if(data.id_notification_type == '17') return 
        //  if(data.id_notification_type == '18') return 
        //  if(data.id_notification_type == '19') return 
        //  if(data.id_notification_type == '20') return 
        //  if(data.id_notification_type == '21') return 
        //  if(data.id_notification_type == '22') return 
        //  if(data.id_notification_type == '23') return 
        //  if(data.id_notification_type == '24') return 
        //  if(data.id_notification_type == '25') return
        //  if(data.id_notification_type == '26') return 
        //  if(data.id_notification_type == '27') return 
        //  if(data.id_notification_type == '28') return 
        //  if(data.id_notification_type == '29') return 
        //  if(data.id_notification_type == '30') return 
        //  if(data.id_notification_type == '31') return 
        //  if(data.id_notification_type == '32') return 
        //  if(data.id_notification_type == '33') return 
        //  if(data.id_notification_type == '34') return 
        //  if(data.id_notification_type == '35') return 
        //  if(data.id_notification_type == '36') return 
        //  if(data.id_notification_type == '37') return 
        //  if(data.id_notification_type == '38') return 
        //  if(data.id_notification_type == '39') return 
        //  if(data.id_notification_type == '40') return 
        //  if(data.id_notification_type == '41') return 

      }
    },
    getBackgroundColor2 (flag_read_notification) {
      if (flag_read_notification === 1) return 'bg-transparent'
      return 'bg-grey-light'
    },
    getIcon (id_notification_type) {
      if (id_notification_type === '1') return 'UserPlusIcon'
      if (id_notification_type === '2') return 'ShieldIcon'
      if (id_notification_type === '3') return 'ShieldIcon'
      if (id_notification_type === '4') return 'ShieldIcon'
      if (id_notification_type === '5') return 'AlertCircleIcon'
      if (id_notification_type === '6') return 'AlertCircleIcon'
      if (id_notification_type === '7') return 'AwardIcon'
      if (id_notification_type === '8') return 'AlertCircleIcon'
      if (id_notification_type === '9') return 'AlertCircleIcon'
      if (id_notification_type === '10') return 'AwardIcon'
      if (id_notification_type === '11') return 'AlertCircleIcon'
      if (id_notification_type === '12') return 'AlertCircleIcon'
      if (id_notification_type === '13') return 'AwardIcon'
      if (id_notification_type === '14') return 'AlertCircleIcon'
      if (id_notification_type === '15') return 'AlertCircleIcon'
      if (id_notification_type === '16') return 'AwardIcon'
      if (id_notification_type === '17') return 'AlertCircleIcon'
      if (id_notification_type === '18') return 'AlertCircleIcon'
      if (id_notification_type === '19') return 'AlertCircleIcon'
      if (id_notification_type === '20') return 'AlertCircleIcon'
      if (id_notification_type === '21') return 'AlertCircleIcon'
      if (id_notification_type === '22') return 'AlertCircleIcon'
      if (id_notification_type === '23') return 'AlertCircleIcon'
      if (id_notification_type === '24') return 'AlertCircleIcon'
      if (id_notification_type === '25') return 'AlertCircleIcon'
      if (id_notification_type === '26') return 'AlertCircleIcon'
      if (id_notification_type === '27') return 'AlertCircleIcon'
      if (id_notification_type === '28') return 'AlertCircleIcon'
      if (id_notification_type === '29') return 'AlertCircleIcon'
      if (id_notification_type === '30') return 'AlertCircleIcon'
      if (id_notification_type === '31') return 'CheckCircleIcon'
      if (id_notification_type === '32') return 'CheckCircleIcon'
      if (id_notification_type === '33') return 'CheckCircleIcon'
      if (id_notification_type === '34') return 'CheckIcon'
      if (id_notification_type === '35') return 'CheckIcon'
      if (id_notification_type === '36') return 'CheckIcon'
      if (id_notification_type === '37') return 'VideoIcon'
      if (id_notification_type === '38') return 'VideoIcon'
      if (id_notification_type === '39') return 'MailIcon'
      if (id_notification_type === '40') return 'UserIcon'
      return 'ActivityIcon'
    },
    getBackgroundColor (id_notification_type) {
      if (id_notification_type === '23') return 'warning'
      if (id_notification_type === '24') return 'warning'
      return 'dark'
    },
    notificacionNoLeida (data) {
      const obj = {
        id_notification: data.id_notification,
        flag_read: 1
      }
      const obj2 = {
        id_notification: data.id_notification,
        flag_read: 0
      }
      if (data.flag_read_notification === 0) {
        this.$store.dispatch('updateNotifications', obj)
      } else {
        this.$store.dispatch('updateNotifications', obj2)
      }
      this.updateNotificaciones()
    },
    updateNotificaciones () {
      this.$vs.loading()
      setTimeout(function () { this.refrescarNotificaciones() }.bind(this), 350)
    },
    refrescarNotificaciones () {
      this.$store.dispatch('fetchNotifications')
      this.$vs.loading.close()
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `hace ${years + (years > 1 ? ' años ' : ' año ')}`
      } else if (days > 0) {
        return `hace ${days + (days > 1 ? ' días ' : ' día ')}`
      } else if (hours > 0) {
        return `hace ${hours + (hours > 1 ? ' horas ' : ' hora ')}`
      } else if (minutes > 0) {
        return `hace ${minutes + (minutes > 1 ? ' minutos ' : ' minuto ')}`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' hace un seg' : 'justo ahora')
      }

      return 'justo ahora'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  },
  created () {
    this.$store.dispatch('fetchNotifications')


  }
}

</script>

